export default "__VITE_ASSET__618e8381__"